import { Injectable, inject, signal } from '@angular/core';
import { ChatRole, DoAction, EntityWhat, EntityWhen, IConversationFlow, IDynamicCondition } from '../models/agent.models';
import { MessagesStateService } from './messages-state.service';
import { EDoActionType, SystemPromptType } from '../components/dc-agent-form/form-group.utils';

@Injectable({
  providedIn: 'root',
})
export class DynamicFlowService {
  private messagesStateService = inject(MessagesStateService);

  // State
  public conversationFlowState = signal<IConversationFlow | null>(null);

  public setConversationFlow(conversationFlow: IConversationFlow): void {
    this.conversationFlowState.set(conversationFlow);
  }

  public changePrompt(): void {
    // This method is currently empty as per requirements.
    console.log('DynamicConditionsService: changePrompt called');
    this.removeSystemPrompts(); // Example call, assuming this is the intended flow
  }

  public doConditions(condition: IDynamicCondition): void {
    condition.do?.forEach((action) => {
      switch (action.actionType) {
        case EDoActionType.ChangePrompt:
          this.doActionPrompt(action);
          break;
        default:
          break;
      }
    });
  }

  public doActionPrompt(action: DoAction): void {
    const prompt = action.prompt;
    const messageId = action.systemPromptType;
    this.messagesStateService.updateMessage(messageId, { content: prompt, role: ChatRole.System }, true);
    console.log('DynamicConditionsService: doActionPrompt called', this.messagesStateService.getMessagesSignal()());
    console.log('DynamicConditionsService: doActionPrompt called');
  }

  public removeSystemPrompts(): void {
    const idsToRemove: string[] = [
      // Ensure idsToRemove is string array
      SystemPromptType.ScenarioDescription,
      SystemPromptType.MessageExamples,
      SystemPromptType.UserInformation,
      SystemPromptType.CharacterDescription,
    ];
    const currentMessages = this.messagesStateService.getMessagesSignal()();
    const filteredMessages = currentMessages.filter((message) => !idsToRemove.includes(message.messageId as string));

    this.messagesStateService.clearMessages();
    filteredMessages.forEach((msg) => this.messagesStateService.addMessage(msg));
    console.log('System prompts removed, messages updated in state:', this.messagesStateService.getMessagesSignal()());
  }

  public checkDynamicConditions(previousScore: number, currentScore: number): void {
    const dynamicConditions = this.conversationFlowState()?.dynamicConditions;
    if (dynamicConditions) {
      dynamicConditions.forEach((condition: IDynamicCondition) => {
        if (condition.what === EntityWhat.Goal) {
          if (condition.when === EntityWhen.GreaterThanOrEqual) {
            const conditionValue = Number(condition.value);
            // Check if the condition was not met before but is met now
            if (previousScore < conditionValue && currentScore >= conditionValue) {
              this.doConditions(condition);
              // alert('Goal Condition met: Score reached ' + conditionValue);
            }
          }
          // Add more condition checks for 'when' if necessary (e.g., LessThanOrEqual, Equal)
        }
        // Add more condition checks for 'what' if necessary
      });
    }
  }
}
